import React from 'react';

export const LocationIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 32, width = 32, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 32 32"
    className={className}
  >
    <path fill="#4C4C4C" d="M16 9c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.4-3-3-3Zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z" />
    <path fill="#000" d="M16.1 5C12.2 5 9 8.2 9 12.1c0 .8.1 1.6.4 2.4.3.9 6 12 6 12 .1.3.4.5.7.5.3 0 .6-.2.7-.5l5.7-11.2.1-.2c.4-.9.6-1.9.6-2.9.1-4-3.2-7.2-7.1-7.2Zm5.6 9.7-5.6 11.1-5.5-10.9-.2-.4c0-.1-.1-.2-.1-.3-.2-.7-.4-1.4-.4-2.1C10 8.8 12.7 6 16.1 6c3.4 0 6.1 2.8 6.1 6.1.1.9-.1 1.8-.5 2.6Z" />
  </svg>
);
